import { Suspense, lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import { PermissionEn } from '@martech-solution/utils/constants';
import type { IResourceFullAccessDetail } from 'src/types/master_data/userResource.type';
import LoadingCustom from 'src/components/v2/Loading';
import templateComponentPath from 'src/constants/urlPath/templateComponentPath';
import marketingRoutes from 'src/routes/crm/marketingRoute';
import masterDataRoutes from 'src/routes/crm/masterDataRoute';
import preSaleRoutes from 'src/routes/crm/preSaleRoute';
import crmCommonRoutes from 'src/routes/commonRoute';
import type { HRTicketCategoryEn } from 'src/types/master_data/hrTicketCategory.type';
import { authRoutes, errorRoutes } from '@martech-solution/utils/routes';

import { usePermissionNew } from './usePermission';
import { Forbidden } from '@martech-solution/utils/pages';

//#region Import components
const TemplateComponent = lazy(() => import('src/pages/TemplateComponent'));

//#endregion STANDARDS QUALITYimport ProductionRequestDetail from './../pages/ContractExecution/Production/ProductionRequest/ProductionRequestDetail/index';

export interface RouteType {
  path: string;
  redirect?: string;
  Layout?: any;
  SubLayout?: any;
  Component?: any;
  permission?: PermissionEn;
  checkPath?: string;
  isUsePathV2?: boolean;
  hasSidebar?: boolean;
  hasSubSidebar?: boolean;
  hasSubHeader?: boolean;
  isHideDetailLayout?: boolean;
  isDisableFooter?: boolean;
  ticketCategoryCode?: HRTicketCategoryEn; // này mới thêm sau để dùng cho bên ERP
}

const routesV2: RouteType[] = [
  ...preSaleRoutes,
  ...crmCommonRoutes,
  ...marketingRoutes,
  ...masterDataRoutes,
  ...preSaleRoutes
];

const commonRoutes: RouteType[] = [
  {
    path: templateComponentPath,
    Component: TemplateComponent
  },
  ...authRoutes,
  ...errorRoutes
];

export default function useRouteElements(resources: IResourceFullAccessDetail[], resourcePermissionLoading: boolean) {
  const permissionResource = usePermissionNew(
    [...routesV2, ...commonRoutes].map((x) => x.path),
    resources
  );

  const hasPermission = (path: string, permission: PermissionEn) => {
    const similarResource = permissionResource?.filter((x) => path?.includes(x?.path as string));
    const mostSimilarPath = similarResource?.reduce((prevPath, currPath) => {
      return (currPath?.path?.length || 0) > (prevPath?.path?.length || 0) ? currPath : prevPath;
    }, similarResource[0]);
    if (mostSimilarPath) {
      return mostSimilarPath?.permissions?.includes(permission);
    }
    return false;
  };

  const routeElements = useRoutes(
    [...routesV2, ...commonRoutes].map(
      ({
        path,
        redirect,
        Layout,
        SubLayout,
        Component,
        permission,
        checkPath,
        hasSidebar,
        hasSubSidebar,
        isDisableFooter,
        isHideDetailLayout,
        hasSubHeader,
        ticketCategoryCode
      }) => {
        // const innerPaths = isUsePathV2 ? pathsV2 : paths;
        const resComponent = redirect ? (
          <Navigate to={redirect} />
        ) : (
          <Component ticketCategoryCode={ticketCategoryCode} />
        );

        if (!SubLayout && Layout) {
          return {
            path,
            element: (
              <Layout isDisableFooter={isDisableFooter} hasSidebar={hasSidebar}>
                <LoadingCustom isLoading={!!resourcePermissionLoading || !resources} message='Đang tải tài nguyên...' />
                {!resourcePermissionLoading && !!resources ? (
                  <Suspense>
                    {
                      // checkPath && !paths?.includes(checkPath) ? (
                      //   <NotFound />
                      // ) :
                      permission && !hasPermission(path, permission) ? <Forbidden /> : resComponent
                    }
                  </Suspense>
                ) : (
                  <></>
                )}
              </Layout>
            )
          };
        } else if (SubLayout && Layout) {
          return {
            path,
            element: (
              <Layout isDisableFooter={isDisableFooter}>
                <Suspense>
                  <SubLayout
                    hasSidebar={hasSidebar}
                    hasSubHeader={hasSubHeader}
                    hasSubSidebar={hasSubSidebar}
                    isHideDetailLayout={isHideDetailLayout}
                  >
                    <Suspense>{permission && !hasPermission(path, permission) ? <Forbidden /> : resComponent}</Suspense>
                  </SubLayout>
                </Suspense>
              </Layout>
            )
          };
        } else
          return {
            path,
            element: resComponent
          };
      }
    )
  );

  return routeElements;
}
